import { useTranslation } from 'react-i18next';

import InfoPurple from '@/shared/assets/info-purple.svg?react';
import { CommentItem } from '@/shared/components/comments/comment-item';
import { CommentBase } from '@/shared/components/comments/comment-type';
import { LoadingIndicator } from '@/shared/components/loading-indicator';
import { Button } from '@/shared/components/ui/button';

export const CommentsList = ({
  isLoading,
  isError,
  comments,
  onDelete,
  onUpdateSeen,
  disableSeen = false,
}: {
  isLoading: boolean;
  isError: boolean;
  comments: CommentBase[];
  onDelete: (id: number) => void;
  onUpdateSeen: (id: number) => void;
  disableSeen?: boolean;
}) => {
  const { t } = useTranslation('project', { keyPrefix: 'Comments' });

  const commentsReversed = [...comments].reverse();

  return isLoading ? (
    <LoadingIndicator />
  ) : !comments || isError ? (
    <span>{t('errors.fetch')}</span>
  ) : (
    // reverse scroll, start from the bottom
    <div className="flex w-full flex-1 flex-col-reverse gap-2">
      {comments.length === 0 ? (
        <div className="flex w-full flex-col items-center justify-center rounded-[8px] bg-[rgba(217,217,217,0.05)] px-[12px] py-[32px]">
          <div className="flex flex-col items-center justify-center gap-[16px]">
            {/* Icon */}
            <Button
              variant={'outline'}
              btnType={'icon'}
              shape={'circle'}
              className="size-12 cursor-default p-1"
            >
              <InfoPurple />
            </Button>

            {/* Text */}
            <div className="flex w-[312px] flex-col items-center gap-[8px]">
              <p className="text-center text-[15px] font-[590] leading-[20px] tracking-[-0.4px] text-[#fefefe]">
                {t('errors.empty')}
              </p>
              <p className="text-center text-[13px] font-normal leading-[18px] tracking-[-0.4px] text-[#fefefe]">
                {t('errors.empty_subtitle')}
              </p>
            </div>
          </div>
        </div>
      ) : (
        commentsReversed.map((comment) => (
          <CommentItem
            key={comment.id}
            comment={comment}
            onDelete={onDelete}
            onUpdateSeen={onUpdateSeen}
            disableSeen={disableSeen}
          />
        ))
      )}
    </div>
  );
};
